import { render, staticRenderFns } from "./op-stage-dialog.vue?vue&type=template&id=201d597b&scoped=true"
import script from "./op-stage-dialog.vue?vue&type=script&lang=ts"
export * from "./op-stage-dialog.vue?vue&type=script&lang=ts"
import style0 from "./op-stage-dialog.vue?vue&type=style&index=0&id=201d597b&prod&lang=scss&scoped=true"
import style1 from "./op-stage-dialog.vue?vue&type=style&index=1&id=201d597b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201d597b",
  null
  
)

export default component.exports